import { type AxiosResponse } from 'axios'
import { httpClient } from '@/apis/index.ts'
import { getAppUrl } from '@/utils'

export const getUserInfo = async () => {
  try {
    const res: AxiosResponse = await httpClient.post(`/iam/user/userInfo`)
    return res.data
  } catch (e) {
    console.log(e)
  }
}

export const changePassword = async () => {
  const res: AxiosResponse = await httpClient.post('/iam/user/request-change-pwd')

  return res.data
}

export async function getAuthInfo() {
  const res = await httpClient.post(`${getAppUrl()}/api/auth/info`)
  return res.data.body
}

export async function logout() {
  try {
    await httpClient.post(`${getAppUrl()}/api/auth/logout`)
  } catch (error) {
    console.error('Error during logout:', error)
  }
}

export async function exchangeToken(clientId: string) {
  try {
    const res = await httpClient.post(`${getAppUrl()}/api/auth/token-exchange`, {
      clientId: clientId
    })
    return res.data.body
  } catch (error) {
    console.error('Error exchanging token:', error)
  }
}
